import {
    LOGIN,
    LOGIN_SUCCEED,
    LOGIN_FAILED,
    LOGOUT,

    SIGNUP,
    SIGNUP_SUCCEED,
    SIGNUP_FAILED,


    CHECK_EXIST,
    CHECK_SUCCEED,
    CHECK_FAILED,

    AUTH_SIGNING,
    AUTH_SIGN_FINISHED,

    GET_USER_INFO,
    GET_USER_INFO_SUCCEED,
    GET_USER_INFO_FAILED,

    GET_RELEASE_DETAIL,
    GET_RELEASE_DETAIL_SUCCEED,
    GET_RELEASE_DETAIL_FAILED,

    SESSION_VALID
} from '../constants';

export function auth (state = {
    checked: false,
    loggedIn: false,
    loggingIn: false,
    loading: false,
    l1DappSigning: false,
    registered: false,
    authMsg: '',
    userInfo: {
        idoInvestment: 0
    },
    releaseDetail:{}
}, action) {
    switch (action.type) {
        case AUTH_SIGNING:
            return {
                ...state,
                loading: true,
                l1DappSigning: true
            }
        case AUTH_SIGN_FINISHED:
            return {
                ...state,
                l1DappSigning: false
        }
        case SIGNUP:
            return {
                ...state,
                loading: true,
                authMsg: '',
            }
        case SIGNUP_SUCCEED:
            return {
                ...state,
                registered: true,
                loading: false,
            }
        case SIGNUP_FAILED:
            return {
                ...state,
                authMsg: action.message,
                loading: false,
            }
        case CHECK_EXIST:
            return {
                ...state,
                loading: true,
                authMsg: ''
            }
        case CHECK_SUCCEED:
            return {
                ...state,
                registered: action.registered,
                checked: true,
                loading: false
            }
        case CHECK_FAILED:
            return {
                ...state,
                authMsg: '',
                loading: false,
                checked:false
            }
        case LOGIN:
            return {
                ...state,
                loggingIn: true,
                authMsg: '',
                errors: action.error ? action.payload.errors : null,
            };
        case LOGIN_SUCCEED:
            return {
                ...state,
                loggedIn: true,
                loggingIn: false,
                token: action.data.data,
                address: action.data.address,
                networkId: action.data.networkId,
                chainId: action.data.chainId,
            };
        case LOGIN_FAILED:
            return {
                ...state,
                loggedIn: false,
                loggingIn: false,
                errors: action,
                authMsg: action.message,
                loading: false,
            };
        case LOGOUT:
            return {
                ...state,
                loggedIn: false,
                token: '',
                loading: false,
                registered: false,
                l1DappSigning: false,
                checked: false
            }

        case GET_USER_INFO_SUCCEED:
            return {
                ...state,
                userInfo: action.data
            }
        case GET_USER_INFO_FAILED:
            return {
                ...state,
                authMsg: action.message
            }

        case GET_RELEASE_DETAIL_SUCCEED:
            return {
                ...state,
                releaseDetail: action.data
            }
        case GET_RELEASE_DETAIL_FAILED:
            return {
                ...state,
                releaseDetailMessage: action.message
            }
        case SESSION_VALID:
            return {
                ...state,
                registered: action.data.registered,
                loggedIn: action.data.loggedIn,
                loggingIn: action.data.loggingIn,
                token: action.data.token,
            }
        default:
            return state;
    }

    return state;
};
